<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="info" aria-label="Home"> <!-- class="navbar-custom" -->
      <b-container fluid>
        <div>
          <b-button v-if="isAdmin" variant="info" id="sidebarCollapse" @click="menuClick">
            <i class='uil uil-bars' style="font-size: 20px"></i>
          </b-button>
          <b-navbar-brand to="/"><i class='mdi mdi-coffee-outline'></i> My Event Cafe</b-navbar-brand>
        </div>
        <b-navbar-toggle target="nav-collapse" label="Alerts">
          <b-badge v-if="newAlerts.length" variant="danger">{{ newAlerts.length }}</b-badge>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <LocaleSelector v-if="!activePage.includes('/about')" />
            <b-nav-item-dropdown v-if="isLoggedIn && helpLinks && helpLinks.length > 0" menu-class="nav-menu notification" right>
              <template v-slot:button-content>
                {{ $t('help') }}
              </template>
              <b-dropdown-item v-for="link in helpLinks" :key="link.id" id="btnProfile" @click="openWindow(link.resourceUrl)"><i class='uil uil-question-circle'></i> {{ link.title }}</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- https://bootstrap-vue.js.org/docs/reference/router-links#common-router-link-props -->
            <b-nav-item data-cy="login" v-if="!isLoggedIn" to='/login'>{{ $t('login') }}</b-nav-item>
            <b-nav-item-dropdown v-if="isLoggedIn" data-cy="btnAlerts" id="btnAlerts" menu-class="nav-menu notification" right> <!-- && this.alerts.length > 0 -->
              <template v-slot:button-content>
                <b-badge :variant="newAlerts.length > 0 ? 'danger' : 'success'">{{ newAlerts.length }}</b-badge> {{ $t('alerts') }}
              </template>
              <b-dropdown-item @click="clearAlerts()"><p class="notification"><i class="mdi mdi-bell-off-outline"></i> {{ $t('clearAlerts') }}</p></b-dropdown-item>
              <template v-for="alert in alerts">
                <b-dropdown-divider :key="'div' + alert.id"></b-dropdown-divider>
                <b-dropdown-item v-if="alert.type === 'Reply' && alert.fromName" :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToAlert(alert.id, alert.eventId, alert.activityId, alert.discussionId)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ $t('comment.replyAlertMsg', [alert.fromName]) }}</p></b-dropdown-item>
                <b-dropdown-item v-else-if="alert.type === 'Reaction' && alert.fromName" :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToAlert(alert.id, alert.eventId, alert.activityId, alert.discussionId)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ $t('comment.reactionAlertMsg', [alert.fromName]) }}</p></b-dropdown-item>
                <b-dropdown-item v-else-if="alert.type === 'Mention' && alert.fromName" :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToAlert(alert.id, alert.eventId, alert.activityId, alert.discussionId)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ $t('comment.mentionAlertMsg', [alert.fromName]) }}</p></b-dropdown-item>
                <b-dropdown-item v-else-if="alert.type === 'DripUserPost' && alert.fromName" :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToAdminDripAlert(alert.id, alert.dripCode)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ $t('comment.dripPostAlertMsg', [alert.fromName]) }}</p></b-dropdown-item>
                <b-dropdown-item v-else-if="alert.type === 'DripAdminPost' && alert.fromName" :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToUserDripAlert(alert.id, alert.dripCode)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ $t('comment.dripPostAlertMsg', [alert.fromName]) }}</p></b-dropdown-item>
                <b-dropdown-item v-else :key="'item' + alert.id" :class="alert.acknowledged == null ? 'unread' : 'read'" @click="navigateToAlert(alert.id, alert.eventId, alert.activityId, alert.discussionId)"><p class="notification"><i :class="alert.acknowledged == null ? 'uil uil-comment' : 'uil uil-comment-verify'"></i> {{ alert.message }}</p></b-dropdown-item>
              </template>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown data-cy="btnAccount" id="btnAccount" v-if="isLoggedIn" menu-class="nav-menu notification" right>
              <template v-slot:button-content>
                <i class="uil uil-user"></i> {{ profile.name.split(' ')[0] }}
              </template>
              <b-dropdown-item v-if="!isAdmin" @click="$router.push('/')"><i class='mdi mdi-calendar-account-outline'></i> {{ $t('user.myClasses') }}</b-dropdown-item>
              <b-dropdown-item id="btnProfile" @click="$router.push('/account/profile')"><i class='uil uil-user'></i> {{ $t('user.profile') }}</b-dropdown-item>
              <b-dropdown-item v-if="isAdmin" id="btnPurchaseHistory" data-cy="purchaseHistory" @click="$router.push('/purchase/templates/history')"><i class='mdi mdi-credit-card-clock-outline'></i> Purchase History</b-dropdown-item>
              <b-dropdown-item v-if="showHangFire()" @click="hangfire"><i class='mdi mdi-clock-time-four-outline'></i> Hangfire</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="$router.push('/about')"><i class='mdi mdi-help-circle-outline'></i> {{ $t('about') }}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item id="btnSignout" @click="logout"><i class='mdi mdi-lock-outline'></i> {{ $t('logout') }}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
import { userServices } from '@/_services'
import LocaleSelector from '@/components/LocaleSelector'

export default {
  components: { LocaleSelector },
  data () {
    return {
      alerts: [],
      helpLinks: null,
      authorizedSeller: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout').then(() => {
        if (this.$route.path === '/') {
          window.location.reload()
        } else {
          this.$router.push('/')
        }
      })
    },
    showHangFire () {
      var val = this.$store.getters.userProfile.email === 'bruce@dropsoffreedom.com' && this.isOwner
      return val
    },
    hangfire () {
      var host = process.env.VUE_APP_API_HOST
      var dest = host + '/hf?access_token=' + this.$store.state.token
      console.log('dest: ' + dest)
      window.location.href = dest
    },
    menuClick () {
      console.log('navbar menu click')
      this.$emit('menuClick')
    },
    openWindow (url) {
      window.open(url, '_blank')
    },
    clearAlerts () {
      userServices.deleteAlerts()
        .then(() => {
          this.alerts = []
        })
        .catch(err => {
          console.log(err)
        })
    },
    navigateToAlert (id, EventId, ActivityId, DiscussionId) {
      userServices.acknowledgeAlert(id)
        .finally(() => {
          this.$router.push({ path: `/event/${EventId}/activity/${ActivityId}?r=${DiscussionId}` }, null, this.getAlerts()).catch((e) => {})
        })
    },
    navigateToUserDripAlert (id, dripCode) {
      // type = 'DripAdminPost'
      userServices.acknowledgeAlert(id)
        .finally(() => {
          this.$router.push({ path: `/drip/${dripCode}` }, null, this.getAlerts()).catch((e) => {})
        })
    },
    navigateToAdminDripAlert (id, dripCode) {
      // type = 'DripUserPost'
      userServices.acknowledgeAlert(id)
        .finally(() => {
          this.$router.push({ path: `/account/drip/${dripCode}/messages` }, null, this.getAlerts()).catch((e) => {})
        })
    },
    getAlerts () {
      userServices.getAlerts(this.$store.getters.userProfile.id)
        .then(response => {
          this.alerts = response
        })
        .catch(err => {
          console.log(err)
        })
    },
    getHelpLinks (ctx) {
      this.helpLinks = null
      userServices.getHelpLinks(ctx)
        .then(response => {
          this.helpLinks = response
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    activePage () {
      return this.$route.path
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    isOwner () {
      if (this.$store.getters.userProfile.roles) {
        return this.$store.getters.userProfile.roles.includes('Owner')
      } else {
        return false
      }
    },
    isAdmin () {
      if (this.$store.getters.userProfile.roles) {
        return this.$store.getters.userProfile.roles.includes('Owner') || this.$store.getters.userProfile.roles.includes('Admin')
      } else {
        return false
      }
    },
    profile () {
      return this.$store.getters.userProfile
    },
    newAlerts () {
      var al = this.alerts.filter(x => x.acknowledged === null)
      return al
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.isLoggedIn) {
        this.getAlerts()
        this.getHelpLinks(to.name)
      }
    },
    '$i18n.locale' () {
      this.$dayjs.locale(this.$i18n.locale)
    }
  },
  mounted () {
    if (this.isLoggedIn) {
      this.getAlerts()
      this.getHelpLinks(this.$route.name)
    }
  }
}
</script>

<style>
/* @media (min-width: 1200px) {
  .container {
      max-width: 100%;
  }
} */

#sidebarCollapse {
  visibility: hidden;
  display: none;
}

@media (max-width: 768px) {
  #sidebarCollapse {
    visibility: visible;
    display: inline;
  }
}

.nav-menu {
  max-width: 400px;
}

.unread a {
  background-color: #8aacc9;
  color: black !important;
}

.read a {
  /* background-color: lightgrey; */
  color: gray !important;
}

.unread a:hover {
  background-color: #547ea0;
  color: white !important;
}

.dropdown-item {
  padding: 0.5rem 1.5rem;
}

.dropdown-divider {
  margin: 0px
}

.notification {
  word-break: normal;
  white-space: normal;
  min-width: 200px;
  margin-block-end: 0px;
}

.navbar .navbar-nav .dropdown-menu .dropdown-item {
  padding-left: 10px !important;
}

.navbar-side {
  height: 100%;
  width: 25%;
  position: fixed;
  top: 0;
  /* left: 0; */
  right: 0;
  padding: 0;
  list-style: none;
  border-left: 2px solid #ccc;
  /* border-right: 2px solid #ccc; */
  background-color: #f7f7f9;
  overflow-y: scroll;
  z-index: 1000;
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: 300ms ease;
  transition: 300ms ease;
}

.reveal {
  -webkit-transform: translateX(0%);
  -ms-transform: translateX(0%);
  transform: translateX(0%);
  -webkit-transition: 300ms ease;
  transition: 300ms ease;
}

.navbar-side-item {
  padding: 1.5rem 0;
  margin: 0;
  border-bottom: 2px solid #ccc;
  height: 5rem;
}

.side-link {
  padding-left: 2rem;
}
</style>
